import React from 'react';
import { PLAYWRIGHT_IGNORE } from '@/lib/constants';
import FooterBottomNav from './FooterBottomNav';
import { FooterBottomNavLinks } from '@/components/Footer/footer.copy';
import Logo from '@/components/Logo';

const NarrowFooter = () => {
  return (
    <section className="text-31xl px-section font-h2-lg overflow-x:hidden box-border flex h-auto w-full items-center justify-center py-3 text-center text-gray-1 md:h-12 md:py-0">
      <div className="max-w-section flex w-full flex-col items-center justify-between md:flex-row">
        <div className="order-last flex w-72 flex-none items-center justify-center md:order-first md:justify-start lg:w-96">
          <p className="w-full text-center text-[10px] font-normal text-black md:text-left lg:text-[11px] lg:text-footnote-sm">
            © {new Date().getFullYear()} Gradle, Inc. Gradle®, Develocity®, Build Scan®, and the Gradlephant logo
            are registered trademarks of Gradle, Inc.
          </p>
        </div>
        <div className="flex min-w-fit shrink items-center justify-center" data-testid={PLAYWRIGHT_IGNORE}>
          <Logo
            width={50}
            height={53}
            alt={'Gradle Elephant Icon'}
            src={'/assets/images/open-source/iconElephant.svg'}
            className="size-10"
          />
        </div>
        <FooterBottomNav navLinks={FooterBottomNavLinks} />
      </div>
    </section>
  );
};

export default NarrowFooter;
